import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPeopleWithGearIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "#aeaeae",
	viewBox: "0 0 128 108",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M32 0A24 24 0 0 0 8 24a24 24 0 0 0 48 0A24 24 0 0 0 32 0v8a16 16 0 0 1 16 16 16 16 0 0 1-32 0A16 16 0 0 1 32 8z" }),
		/* @__PURE__ */ _jsx("path", { d: "M0 72a32 32 0 1 1 64 0h-8a24 24 0 1 0-48 0ZM88 0a24 24 0 0 0-24 24 24 24 0 0 0 48 0A24 24 0 0 0 88 0v8a16 16 0 0 1 16 16 16 16 0 0 1-32 0A16 16 0 0 1 88 8z" }),
		/* @__PURE__ */ _jsx("path", { d: "M56 72a32 32 0 0 1 32-32v8a24 24 0 0 0-24 24Zm40.4-20v8.4c-2.4.4-4.8 1.6-6.8 2.8l-6-6-5.6 5.6 6 6c-1.6 2-2.4 4.4-2.8 7.2H72v8h9.2c.4 2.4 1.6 4.8 2.8 7.2l-6 6 5.6 5.6 6-6c2 1.2 4.4 2.4 6.8 2.8v8.4h8v-8.4c2.4-.4 4.8-1.6 6.8-2.8l6 6 5.6-5.6-6-6c1.6-2 2.4-4.4 2.8-7.2h8.4v-8h-8.4c-.4-2.4-1.6-4.8-2.8-7.2l6-6-5.6-5.6-6 6c-2-1.2-4.4-2.4-6.8-2.8V52zm3.6 16c6.8 0 12 5.2 12 12s-5.2 12-12 12-12-5.2-12-12 5.2-12 12-12m-.3 8a4 4 0 0 0-3.7 4 4 4 0 0 0 8 0 4 4 0 0 0-4.3-4" })
	]
});
const ForwardRef = forwardRef(SvgPeopleWithGearIcon);
export default ForwardRef;
